import { PureComponent } from 'react'
import { $ } from 'utils'
import styled from 'glamorous'
import map from 'lodash/map'
import Route from 'react-router-dom/Route'
import Redirect from 'react-router-dom/Redirect'
import Switch from 'react-router-dom/Switch'
import { withRouter } from 'react-router-dom'
import { graphql } from 'react-apollo'
import Link from 'react-router-dom/Link'

import { Persons, Faces, ListRoutes, Tokens, SearchPage } from 'pages'
import { Icon, Tooltip } from 'components'
import { CHECK_ACCOUNT as query, LogOutMutation } from 'queries'
import { client } from 'config'

import Search from './Search'
import LeftPanel from './LeftPanel'


const MainContainer = styled.div({
  height: '100%',
  width: '100%',
  display: 'flex',
})

const Content = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  background: 'var(--bgColor)'
})

const TopPanelContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: 'white',
  marginLeft: '3px',
  paddingRight: 'calc((100% - 1152px) / 2)'
})

const TopButtons = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  width: 120
})

const Email = styled.div({
  fontSize: 16,
  marginLeft: 10,
  marginRight: 10,
  color: 'var(--lightGrey)'
})

const Page = styled.div({
  margin: '30px auto 0',
  maxWidth: 1152,
  flex: 1,
  overflow: 'hidden'
})

const pages = {
  dashboard: () => 'Dashboard will be here',
  persons: () => $(Persons),
  faces: () => $(Faces),
  list: () => $(ListRoutes)
}

const PageRoute = (component, type) =>
  $(Route, { key: type, type, path: `/${type}`, component })

class MainLayout extends PureComponent {

  logout = () =>
    this.props.mutate({
      update: (proxy) => {
        client.cache.reset()
        proxy.writeQuery({ query, data: { account: null } })
      }
    })
      .then(() => this.props.history.push('/'))

  render() {
    const selectedPage = this.props.location.pathname
    return (
      $(MainContainer,
        $(LeftPanel, { pages }),
        $(Content,
          $(TopPanelContainer,
            $(Search, { push: this.props.history.push }),
            $(Email, this.props.email),
            $(TopButtons,
              $(Tooltip, { tip: 'Tokens', position: 'bottom' },
                $(Link, { to: '/tokens' },
                  $(Icon, {
                    type: 'token',
                    isRoundEffect: true,
                    colorActive: 'var(--violet)',
                    isActive: selectedPage.indexOf('/tokens') === 0
                  })
                )
              ),
              $(Tooltip, { tip: 'Support', position: 'bottom' },
                $(Icon, {
                  type: 'support',
                  isRoundEffect: true
                })
              ),
              $(Tooltip, { tip: 'Logout', position: 'bottom' },
                $(Icon, {
                  type: 'exit',
                  isRoundEffect: true,
                  onClick: this.logout
                })
              )
            )
          ),
          $(Page,
            $(Switch,
              map(pages, PageRoute),
              $(Route, { path: '/tokens', component: Tokens}),
              $(Route, { path: '/search/:search', component: SearchPage}),
              $(Redirect, { to: '/persons' })
            )
          )
        )
      )
    )
  }
}


const MainLayoutWithRouter = withRouter(MainLayout)

export default graphql(LogOutMutation)(MainLayoutWithRouter)



// WEBPACK FOOTER //
// ./src/pages/MainLayout/index.js